import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.primary.contrastText,
    lineHeight: "1.75",
    backgroundColor: theme.palette.primary.main,
    borderRadius: 2,
    margin: 2,
    padding: 0
  },
  label: {
    color: theme.palette.primary.contrastText,
    padding: "3px 6px",
    borderRadius: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: theme.typography.caption.fontSize
  },
  deleteIcon: {
    cursor: "pointer",
    fill: theme.palette.primary.contrastText,
    height: "100%",
    width: 14,
    padding: theme.spacing(0, 0.5),
    boxSizing: "content-box",
    margin: 0,
    marginLeft: theme.spacing(-0.5),
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, .15)"
    }
  },
  deletable: {
    "&:focus": {
      backgroundColor: theme.palette.primary.dark
    }
  },
  draggable: {
    display: "inline-block"
  }
}));
export default useStyles;